import { getThumbnailKey, getIsometricKey } from '@/shared/lib/s3Keys'

export function getThumbnailSmallUrl(fileId: string, customUrl?: string | null): string {
  if (customUrl) return customUrl
  return getThumbnailKey(fileId, 'small')
}

export function getThumbnailLargeUrl(fileId: string, customUrl?: string | null): string {
  if (customUrl) return customUrl
  return getThumbnailKey(fileId, 'large')
}

export function getPreviewUrl(fileId: string, customUrl?: string | null): string {
  if (customUrl) return customUrl
  return getThumbnailKey(fileId, 'large')
}

export function getIsometricViewUrl(fileId: string): string {
  return getIsometricKey(fileId)
}

export function getThumbnailUrls(fileId: string, smallCustomUrl?: string | null, largeCustomUrl?: string | null) {
  return {
    small: getThumbnailSmallUrl(fileId, smallCustomUrl),
    large: getThumbnailLargeUrl(fileId, largeCustomUrl),
  }
}
